import { render, staticRenderFns } from "./AlphabetImage.vue?vue&type=template&id=34550f10&"
import script from "./AlphabetImage.vue?vue&type=script&lang=js&"
export * from "./AlphabetImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports